/* Lauven — « Trouver ma taille » (05/10, inspire de Kiwi Sizing, sans appli payante).
   3 questions courtes : taille habituelle, tour de poitrine (facultatif), tombe prefere.
   Calcul : taille habituelle corrigee par le tombe de la robe (metafield fit_feedback),
   puis tour de poitrine compare aux mesures VETEMENT du guide (on ne serre jamais :
   on garde la plus grande des deux). Le profil est garde dans le navigateur : la taille
   conseillee s'affiche ensuite sur chaque fiche visitee, comme chez Kiwi.
   Aucune statistique inventee : les seuils d'aisance sont des valeurs de depart. */
(() => {
  if (window.__lvReco) return;
  window.__lvReco = true;
  const TAILLES = ['XS', 'S', 'M', 'L', 'XL'];
  const EQUIV = { XS: 'EU 34<br>UK 6 · US 2', S: 'EU 36<br>UK 8 · US 4', M: 'EU 38<br>UK 10 · US 6', L: 'EU 40<br>UK 12 · US 8', XL: 'EU 42<br>UK 14 · US 10' };
  const POITRINE_VETEMENT = [81, 86, 91, 97, 102]; // guide des tailles maison (mesures vetement, cm)
  const AISANCE = { pres: -2, normal: 0, ample: 4 }; // valeurs de depart, a regler sur les retours
  const CLE = 'lv_taille_profil';

  const box = () => document.querySelector('.lv-reco');
  const T = (k, d) => {
    try { return JSON.parse(document.getElementById('lv-reco-i18n').textContent)[k] || d; } catch (e) { return d; }
  };
  const lire = () => { try { return JSON.parse(localStorage.getItem(CLE)) || null; } catch (e) { return null; } };
  const ecrire = (p) => { try { localStorage.setItem(CLE, JSON.stringify(p)); } catch (e) {} };

  function taillesProduit() {
    const fs = document.querySelector('.lv-fs-taille') || document.querySelector('[id$="__main"] variant-picker fieldset');
    if (!fs) return [];
    return [...fs.querySelectorAll('input[type="radio"]')].map((i) => ({ v: i.value.trim().toUpperCase(), dispo: i.dataset.optionAvailable !== 'false', input: i }));
  }

  function calcul(p) {
    const fit = (box() && box().dataset.fit) || '';
    let i = TAILLES.indexOf(p.usual);
    const raisons = [];
    if (i < 0) i = 1;
    if (fit === 'runs_small') { i += 1; raisons.push(T('why_small', 'This dress runs small, so we suggest one size up.')); }
    else if (fit === 'runs_large') { i -= 1; raisons.push(T('why_large', 'This dress runs large, so we suggest one size down.')); }
    else if (fit === 'true_to_size') raisons.push(T('why_true', 'This dress fits true to size.'));
    else raisons.push(T('why_usual', 'Based on the size you usually wear.'));
    if (p.bust) {
      const besoin = p.bust + (AISANCE[p.pref] || 0);
      let j = POITRINE_VETEMENT.findIndex((c) => c >= besoin);
      if (j < 0) j = 4;
      if (j > i) { i = j; raisons.push(T('why_bust', 'Based on your bust, {size} gives you room to move.').replace('{size}', TAILLES[Math.min(j, 4)])); }
    }
    i = Math.max(0, Math.min(4, i));
    const reco = TAILLES[i];
    const alt = p.pref === 'ample' || i === 0 ? TAILLES[Math.min(i + 1, 4)] : null;
    return { reco, alt: alt !== reco ? alt : null, raisons };
  }

  function afficherLigne() {
    const b = box();
    if (!b) return;
    const p = lire();
    const lien = b.querySelector('.lv-reco__lien');
    const res = b.querySelector('.lv-reco__memo');
    if (p) {
      const r = calcul(p);
      res.innerHTML = '';
      const s = document.createElement('span');
      s.textContent = T('saved', 'Your recommended size: {size}').replace('{size}', r.reco);
      res.append(s);
      res.hidden = false;
      lien.textContent = T('change', 'Change');
    } else {
      res.hidden = true;
      lien.textContent = T('link', 'Find my size');
    }
    b.hidden = false;
  }

  function choisirTaille(t) {
    const x = taillesProduit().find((o) => o.v === t);
    if (!x) return false;
    const lab = x.input.closest('label') || document.querySelector(`label[for="${x.input.id}"]`);
    (lab || x.input).click();
    return true;
  }

  function ouvrir() {
    const p = lire() || { usual: null, bust: null, pref: 'normal' };
    let d = document.getElementById('lv-reco-dialog');
    if (d) d.remove();
    d = document.createElement('dialog');
    d.id = 'lv-reco-dialog';
    d.className = 'lv-reco-dialog';
    document.body.append(d);
    let etape = 1;
    let unite = 'cm';

    const rendre = () => {
      const titre = { 1: T('q1', 'Which size do you usually wear?'), 2: T('q2', 'Your bust measurement (optional)'), 3: T('q3', 'How do you like your dresses to fit?') };
      let corps = '';
      if (etape === 1) {
        corps = '<div class="lv-reco__grille">' + TAILLES.map((t) => `<button type="button" class="lv-reco__opt${p.usual === t ? ' is-on' : ''}" data-usual="${t}"><strong>${t}</strong><small>${EQUIV[t]}</small></button>`).join('') + '</div>';
      } else if (etape === 2) {
        const val = p.bust ? (unite === 'cm' ? p.bust : Math.round(p.bust / 2.54)) : '';
        corps = `<p class="lv-reco__aide">${T('q2_help', 'Measure around the fullest part of your bust.')}</p>
          <div class="lv-reco__mesure"><input type="number" inputmode="decimal" min="${unite === 'cm' ? 60 : 24}" max="${unite === 'cm' ? 150 : 60}" value="${val}" aria-label="${T('q2', 'Bust')}">
          <button type="button" class="lv-reco__unite" data-unite="cm"${unite === 'cm' ? ' aria-pressed="true"' : ''}>cm</button><button type="button" class="lv-reco__unite" data-unite="in"${unite === 'in' ? ' aria-pressed="true"' : ''}>in</button></div>
          <button type="button" class="lv-reco__passer">${T('q2_skip', "I don't know")}</button>`;
      } else if (etape === 3) {
        corps = '<div class="lv-reco__liste">' + [['pres', T('fit_close', 'Close to the body')], ['normal', T('fit_regular', 'Regular')], ['ample', T('fit_loose', 'Relaxed')]].map(([k, l]) => `<button type="button" class="lv-reco__opt${p.pref === k ? ' is-on' : ''}" data-pref="${k}">${l}</button>`).join('') + '</div>';
      } else {
        const r = calcul(p);
        const dispo = taillesProduit().find((o) => o.v === r.reco);
        corps = `<p class="lv-reco__res">${T('result', 'Your size: {size}').replace('{size}', `<strong>${r.reco}</strong>`)}</p>
          <ul class="lv-reco__raisons">${r.raisons.map((x) => `<li>${x}</li>`).join('')}</ul>
          ${r.alt ? `<p class="lv-reco__alt">${T('alt', 'Between two sizes? Take {size} for a looser fit.').replace('{size}', r.alt)}</p>` : ''}
          ${dispo && !dispo.dispo ? `<p class="lv-reco__alt">${T('oos', '{size} is sold out in this dress.').replace('{size}', r.reco)}</p>` : ''}
          <p class="lv-reco__note">${T('note', 'A suggestion based on the garment measurements — you can still exchange it.')}</p>`;
      }
      const pied = etape < 4
        ? `${etape > 1 ? `<button type="button" class="lv-reco__retour">${T('back', 'Back')}</button>` : '<span></span>'}<button type="button" class="lv-reco__suite"${etape === 1 && !p.usual ? ' disabled' : ''}>${T('next', 'Next')}</button>`
        : `<button type="button" class="lv-reco__retour">${T('back', 'Back')}</button><button type="button" class="lv-reco__choisir">${T('choose', 'Select {size}').replace('{size}', calcul(p).reco)}</button>`;
      d.innerHTML = `<div class="lv-reco__cadre"><div class="lv-reco__tete"><span class="lv-reco__etape">${Math.min(etape, 3)}/3</span><button type="button" class="lv-reco__fermer" aria-label="${T('close', 'Close')}">×</button></div>
        <h2 class="lv-reco__titre">${etape < 4 ? titre[etape] : T('result_title', 'Our suggestion')}</h2>${corps}<div class="lv-reco__pied">${pied}</div></div>`;
    };

    d.addEventListener('click', (e) => {
      const t = e.target.closest('button');
      if (e.target === d || (t && t.classList.contains('lv-reco__fermer'))) { d.close(); return; }
      if (!t) return;
      if (t.dataset.usual) { p.usual = t.dataset.usual; etape = 2; rendre(); return; }
      if (t.dataset.pref) { p.pref = t.dataset.pref; etape = 4; ecrire(p); rendre(); afficherLigne(); return; }
      if (t.dataset.unite) { lireMesure(); unite = t.dataset.unite; rendre(); return; }
      if (t.classList.contains('lv-reco__passer')) { p.bust = null; etape = 3; rendre(); return; }
      if (t.classList.contains('lv-reco__suite')) { if (etape === 2) lireMesure(); etape = Math.min(etape + 1, 4); if (etape === 4) { ecrire(p); afficherLigne(); } rendre(); return; }
      if (t.classList.contains('lv-reco__retour')) { etape = etape === 4 ? 3 : Math.max(1, etape - 1); rendre(); return; }
      if (t.classList.contains('lv-reco__choisir')) { choisirTaille(calcul(p).reco); d.close(); }
    });
    function lireMesure() {
      const i = d.querySelector('.lv-reco__mesure input');
      if (!i) return;
      const v = parseFloat(String(i.value).replace(',', '.'));
      p.bust = v > 0 ? Math.round(unite === 'cm' ? v : v * 2.54) : null;
    }
    rendre();
    d.showModal();
    // sans ca, le navigateur met le focus sur le 1er bouton (XS) : il paraissait preselectionne
    const cadre = d.querySelector('.lv-reco__cadre');
    if (cadre) { cadre.tabIndex = -1; cadre.style.outline = 'none'; cadre.focus(); }
  }

  document.addEventListener('click', (e) => {
    const l = e.target instanceof Element && e.target.closest('.lv-reco__lien');
    if (!l) return;
    e.preventDefault();
    ouvrir();
  });

  const placer = () => {
    const b = box();
    const fs = document.querySelector('.lv-fs-taille');
    if (b && fs && b.previousElementSibling !== fs) {
      const ech = document.querySelector('.lv-taille-echange');
      (ech && ech.parentElement === fs.parentElement ? ech : fs).after(b);
    }
    afficherLigne();
  };
  const demarrer = () => {
    placer();
    const pk = document.querySelector('[id$="__main"] variant-picker');
    if (pk) new MutationObserver(() => requestAnimationFrame(placer)).observe(pk, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(demarrer, 50));
  else setTimeout(demarrer, 50);
})();
